import { useState } from 'react';
import { useForm } from 'react-hook-form';
import useCallApiAndLoad from '../../../hooks/useCallApiAndLoad';
import { uploadTowerBackgroundV2Endpoint } from '../../withdrawal/services/projectService';
import useAuth from '../../../hooks/useAuth';
import { useNavigate, useParams } from 'react-router-dom';
import { CreateImageTowerV2 } from '../models/towerLayoutModelV2';

const useCreateImageTowerV2 = () => {
  const { id = '' } = useParams();
  const { callEndpoint, isLoading } = useCallApiAndLoad();
  const { getAuthToken } = useAuth();
  const token = getAuthToken();
  const navigate = useNavigate();

  const {
    handleSubmit,
    setValue,
    register,
  } = useForm<CreateImageTowerV2>();

  const addCurrentImage = async (form: FormData) => {
    const { status, data } = await callEndpoint(
      uploadTowerBackgroundV2Endpoint(id, form, token),
    );
    if (status === 200 || status === 201) {
      navigate(0);
    }
  };

  return {
    register,
    handleSubmit,
    setValue,
    isLoading,
    addCurrentImage,
  };
};

export default useCreateImageTowerV2;
